<template>
  <div
    class="c-app flex-row align-items-center"
    style="
         height: 100%;
        background-position: center;
        width: 100%;"
  >
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
          in-header
          class="ml-3 d-md-down-none"
          @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="d-lg-none">
          <h3>
            <b>
              <font color="Green">MINING</font>
              <font color="gray">OPERATION</font></b
            >
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <CHeaderNavItem class="px-3">
            <h3>
              <b>
                <font color="Green">MINING</font>
                <font color="gray">OPERATION</font></b
              >
            </h3>
          </CHeaderNavItem>
        </CHeaderNav>
      </CHeader>
      <div class="c-body">
        <main class="c-main">
          <CRow>
            <CCol class="amsys-dashboard-parameter">
              <select
                class="form-control"
                style="font-weight: bold; font-size:18px;"
                @change="reloadData()"
                v-model="selectedBep"
              >
                <option value="" selected="selected">
                  SELECT BEP
                </option>
                <option
                  v-for="item in bepResult"
                  :value="item.Code"
                  :key="item.Code"
                >
                  {{ item.Code.toUpperCase() }}
                </option>
                <option value="OHT" key="OHT">
                  HAULER OHT
                </option>
              </select>
            </CCol>

            <CCol class="amsys-dashboard-parameter2">
              <select
                class="form-control"
                style="font-weight: bold; font-size:18px;"
                @change="reloadData()"
                v-model="selectedCompany"
              >
                <option value="" selected="selected">
                  SELECT COMPANY
                </option>
                <option
                  v-for="item in companyResult"
                  :value="item.Company"
                  :key="item.Code"
                >
                  {{ item.Code }}
                </option>
              </select>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">SUMMARY</font></b>
                  </h5>
                </div>
                <div class="card-body">
                  <CCol style="width: 100%;padding: 0px;">
                    <DxPieChart
                      v-if="selectedBep != ''"
                      id="pie"
                      :data-source="dashboardMop"
                      palette="Bright"
                    >
                      <DxSeries argument-field="bep" value-field="qty">
                        <DxLabel
                          :visible="true"
                          :customize-text="formatLabel"
                          position="columns"
                        >
                          <DxConnector :visible="true" :width="0.5" />
                          <DxFont :size="16" />
                        </DxLabel>
                      </DxSeries>
                      <DxLegend
                        :column-count="4"
                        orientation="horizontal"
                        item-text-position="right"
                        horizontal-alignment="center"
                        vertical-alignment="bottom"
                      />
                      <DxTooltip
                        :enabled="true"
                        :customize-tooltip="pieCustomizeTooltip"
                      />
                      <DxExport :enabled="false" />
                    </DxPieChart>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b>
                      <font color="white"
                        >BEP {{ selectedBep.toUpperCase() }} BREAKDOWN LIST ({{
                          this.breakDownResult.length
                        }})</font
                      ></b
                    >
                  </h5>
                </div>
                <div class="card-body" style="padding-top: 0.2rem;">
                  <CCol style="width: 100%;padding: 0px;">
                    <CRow class="padding-header3">
                      <CCol class="amsys-dashboard-parameter2">
                        <table
                          v-if="showTable == true"
                          v-for="item in this.breakDownResult"
                          :key="item.Date"
                          style="filter: alpha(opacity=40); margin-bottom: 5px;"
                          border="0"
                        >
                          <tr>
                            <td
                              rowspan="2"
                              width="25%;"
                              style="vertical-align : middle;text-align:left; padding:0px !important;"
                            >
                              <font size="5" style="color: cornflowerblue;">
                                <b> {{ item.EquipmentCode }}</b></font
                              >
                            </td>
                            <td width="65%;" style="padding:0px !important;">
                              {{ item.EquipmentName }}
                            </td>
                            <td
                              rowspan="2"
                              width="15%;"
                              style="vertical-align : middle;text-align:center;padding:0px !important;"
                              v-on:click="showModalBreakdown(item)"
                            >
                              <svg
                                width="20px"
                                height="20px"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style="color:dodgerblue;"
                              >
                                <g>
                                  <path fill="none" d="M0 0h24v24H0z" />
                                  <path
                                    fill="dodgerblue"
                                    d="M18.033 16.618l4.28 4.281-1.414 1.415-4.28-4.281A8.963 8.963 0 0 1 11 20a8.998 8.998 0 0 1-8.065-5H9l-1.304 2.173A6.972 6.972 0 0 0 11 18a6.977 6.977 0 0 0 4.875-1.975l.15-.15A6.977 6.977 0 0 0 18 11c0-.695-.101-1.366-.29-2h2.067c.146.643.223 1.313.223 2a8.963 8.963 0 0 1-1.967 5.618zM19.065 7H13l1.304-2.173A6.972 6.972 0 0 0 11 4c-3.868 0-7 3.132-7 7 0 .695.101 1.366.29 2H2.223A9.038 9.038 0 0 1 2 11c0-4.973 4.027-9 9-9a8.998 8.998 0 0 1 8.065 5z"
                                  />
                                </g>
                              </svg>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="padding:0px !important; background-color:white; color:grey;"
                            >
                              {{ item.Note }}
                            </td>
                          </tr>
                          <tr style="padding:0px !important;">
                            <td style="padding:0px !important;" colspan="3">
                              <hr
                                style="margin-top: 0rem; margin-bottom: 0rem;"
                              />
                            </td>
                          </tr>
                        </table>
                      </CCol>
                    </CRow>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b>
                      <font color="white"
                        >BEP {{ selectedBep.toUpperCase() }} OPERATIONAL LIST
                        ({{ this.operationalList.length }})</font
                      ></b
                    >
                  </h5>
                </div>
                <div class="card-body" style="padding-top: 0.2rem;">
                  <CCol style="width: 100%;padding: 0px;">
                    <CRow class="padding-header3">
                      <CCol class="amsys-dashboard-parameter2">
                        <table
                          v-if="showTable == true"
                          v-for="item in this.operationalList"
                          :key="item.Date"
                          style="filter: alpha(opacity=40); margin-bottom: 5px;"
                          border="0"
                        >
                          <tr>
                            <td
                              rowspan="2"
                              width="25%;"
                              style="vertical-align : middle;text-align:left; padding:0px !important;"
                            >
                              <font size="5" style="color: cornflowerblue;">
                                <b> {{ item.EquipmentCode }}</b></font
                              >
                            </td>
                            <td width="65%;" style="padding:0px !important;">
                              {{ item.EquipmentName }}
                            </td>
                            <td
                              rowspan="2"
                              width="15%;"
                              style="vertical-align : middle;text-align:left;padding:0px !important;"
                            >
                              <svg
                                width="20px"
                                height="20px"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style="color:dodgerblue;"
                                v-on:click="showModalOperational(item)"
                              >
                                <g>
                                  <path fill="none" d="M0 0h24v24H0z" />
                                  <path
                                    fill="dodgerblue"
                                    d="M18.033 16.618l4.28 4.281-1.414 1.415-4.28-4.281A8.963 8.963 0 0 1 11 20a8.998 8.998 0 0 1-8.065-5H9l-1.304 2.173A6.972 6.972 0 0 0 11 18a6.977 6.977 0 0 0 4.875-1.975l.15-.15A6.977 6.977 0 0 0 18 11c0-.695-.101-1.366-.29-2h2.067c.146.643.223 1.313.223 2a8.963 8.963 0 0 1-1.967 5.618zM19.065 7H13l1.304-2.173A6.972 6.972 0 0 0 11 4c-3.868 0-7 3.132-7 7 0 .695.101 1.366.29 2H2.223A9.038 9.038 0 0 1 2 11c0-4.973 4.027-9 9-9a8.998 8.998 0 0 1 8.065 5z"
                                  />
                                </g>
                              </svg>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="padding:0px !important; background-color:white; color:grey;"
                            >
                              {{ item.Note }}
                            </td>
                          </tr>
                          <tr style="padding:0px !important;">
                            <td style="padding:0px !important;" colspan="3">
                              <hr
                                style="margin-top: 0rem; margin-bottom: 0rem;"
                              />
                            </td>
                          </tr>
                        </table>
                      </CCol>
                    </CRow>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b>
                      <font color="white"
                        >BEP {{ selectedBep.toUpperCase() }} STANDBY LIST ({{
                          this.standbyList.length
                        }})</font
                      ></b
                    >
                  </h5>
                </div>
                <div class="card-body" style="padding-top: 0.2rem;">
                  <CCol style="width: 100%;padding: 0px;">
                    <CRow class="padding-header3">
                      <CCol class="amsys-dashboard-parameter2">
                        <table
                          v-if="showTable == true"
                          v-for="item in this.standbyList"
                          :key="item.Date"
                          style="filter: alpha(opacity=40); margin-bottom: 5px;"
                          border="0"
                        >
                          <tr>
                            <td
                              rowspan="2"
                              width="25%;"
                              style="vertical-align : middle;text-align:left; padding:0px !important;"
                            >
                              <font size="5" style="color: cornflowerblue;">
                                <b> {{ item.EquipmentCode }}</b></font
                              >
                            </td>
                            <td width="65%;" style="padding:0px !important;">
                              {{ item.EquipmentName }}
                            </td>
                            <td
                              rowspan="2"
                              width="15%;"
                              style="vertical-align : middle;text-align:center;padding:0px !important;"
                            >
                              <svg
                                width="20px"
                                height="20px"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style="color:dodgerblue;"
                                v-on:click="showModalStandBy(item)"
                              >
                                <g>
                                  <path fill="none" d="M0 0h24v24H0z" />
                                  <path
                                    fill="dodgerblue"
                                    d="M18.033 16.618l4.28 4.281-1.414 1.415-4.28-4.281A8.963 8.963 0 0 1 11 20a8.998 8.998 0 0 1-8.065-5H9l-1.304 2.173A6.972 6.972 0 0 0 11 18a6.977 6.977 0 0 0 4.875-1.975l.15-.15A6.977 6.977 0 0 0 18 11c0-.695-.101-1.366-.29-2h2.067c.146.643.223 1.313.223 2a8.963 8.963 0 0 1-1.967 5.618zM19.065 7H13l1.304-2.173A6.972 6.972 0 0 0 11 4c-3.868 0-7 3.132-7 7 0 .695.101 1.366.29 2H2.223A9.038 9.038 0 0 1 2 11c0-4.973 4.027-9 9-9a8.998 8.998 0 0 1 8.065 5z"
                                  />
                                </g>
                              </svg>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="padding:0px !important; background-color:white; color:grey;"
                            >
                              {{ item.Note }}
                            </td>
                          </tr>
                          <tr style="padding:0px !important;">
                            <td style="padding:0px !important;" colspan="3">
                              <hr
                                style="margin-top: 0rem; margin-bottom: 0rem;"
                              />
                            </td>
                          </tr>
                        </table>
                      </CCol>
                    </CRow>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b>
                      <font color="white"
                        >BEP {{ selectedBep.toUpperCase() }} READY LIST ({{
                          this.readyList.length
                        }})</font
                      ></b
                    >
                  </h5>
                </div>
                <div class="card-body" style="padding-top: 0.2rem;">
                  <CCol style="width: 100%;padding: 0px;">
                    <CRow class="padding-header3">
                      <CCol class="amsys-dashboard-parameter2">
                        <table
                          v-if="showTable == true"
                          v-for="item in this.readyList"
                          :key="item.Date"
                          style="filter: alpha(opacity=40); margin-bottom: 5px;"
                          border="0"
                        >
                          <tr>
                            <td
                              rowspan="2"
                              width="25%;"
                              style="vertical-align : middle;text-align:left; padding:0px !important;"
                            >
                              <font size="5" style="color: cornflowerblue;">
                                <b> {{ item.EquipmentCode }}</b></font
                              >
                            </td>
                            <td width="65%;" style="padding:0px !important;">
                              {{ item.EquipmentName }}
                            </td>
                            <td
                              rowspan="2"
                              width="15%;"
                              style="vertical-align : middle;text-align:center;padding:0px !important;"
                            >
                              <svg
                                width="20px"
                                height="20px"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                style="color:dodgerblue;"
                                v-on:click="showModalReady(item)"
                              >
                                <g>
                                  <path fill="none" d="M0 0h24v24H0z" />
                                  <path
                                    fill="dodgerblue"
                                    d="M18.033 16.618l4.28 4.281-1.414 1.415-4.28-4.281A8.963 8.963 0 0 1 11 20a8.998 8.998 0 0 1-8.065-5H9l-1.304 2.173A6.972 6.972 0 0 0 11 18a6.977 6.977 0 0 0 4.875-1.975l.15-.15A6.977 6.977 0 0 0 18 11c0-.695-.101-1.366-.29-2h2.067c.146.643.223 1.313.223 2a8.963 8.963 0 0 1-1.967 5.618zM19.065 7H13l1.304-2.173A6.972 6.972 0 0 0 11 4c-3.868 0-7 3.132-7 7 0 .695.101 1.366.29 2H2.223A9.038 9.038 0 0 1 2 11c0-4.973 4.027-9 9-9a8.998 8.998 0 0 1 8.065 5z"
                                  />
                                </g>
                              </svg>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="padding:0px !important; background-color:white; color:grey;"
                            >
                              {{ item.Note }}
                            </td>
                          </tr>
                          <tr style="padding:0px !important;">
                            <td style="padding:0px !important;" colspan="3">
                              <hr
                                style="margin-top: 0rem; margin-bottom: 0rem;"
                              />
                            </td>
                          </tr>
                        </table>
                      </CCol>
                    </CRow>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
        </main>
      </div>
      <CRow class="justify-content-center">
        <div
          id="loading-contentx"
          v-if="loading"
          style="margin-bottom: 20%;"
        ></div>
      </CRow>
    </CWrapper>
    <CModal
      :show.sync="modalBreakdown"
      size="sm"
      color="info"
      style="margin-top: 30%;"
    >
      <font style="font-size: 14px; width: 80%;"><b>EQUIPMENT DETAIL </b></font>
      <hr />
      <table style="font-size:13px;">
        <tr>
          <td style="padding: 0.3rem; width:25%;">
            Code
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ breakdown.EquipmentCode }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Name
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ breakdown.EquipmentName }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Category
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ breakdown.BDCategory }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Duration
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ breakdown.Duration }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Status HM
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ breakdown.StatusHM }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Status Date
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ breakdown.StatusDate }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Note
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ breakdown.Note }}
          </td>
        </tr>
      </table>

      <template #footer>
        <CButton
          @click="modalBreakdown = false"
          color="secondary"
          style="font-size: 14px;"
          >Close</CButton
        >
      </template>
    </CModal>
    <CModal
      :show.sync="modalStandBy"
      size="sm"
      color="info"
      style="margin-top: 30%;"
    >
      <font style="font-size: 14px; width: 80%;"><b>EQUIPMENT DETAIL </b></font>
      <hr />
      <table style="font-size:13px;">
        <tr>
          <td style="padding: 0.3rem; width:25%;">
            Code
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ standBy.EquipmentCode }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Name
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ standBy.EquipmentName }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Duration
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ standBy.Duration }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Status Date
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ standBy.StatusDate }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Note
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ standBy.Note }}
          </td>
        </tr>
      </table>

      <template #footer>
        <CButton
          @click="modalStandBy = false"
          color="secondary"
          style="font-size: 14px;"
          >Close</CButton
        >
      </template>
    </CModal>
    <CModal
      :show.sync="modalOperational"
      size="sm"
      color="info"
      style="margin-top: 30%;"
    >
      <font style="font-size: 14px; width: 80%;"><b>EQUIPMENT DETAIL </b></font>
      <hr />
      <table style="font-size:13px;">
        <tr>
          <td style="padding: 0.3rem; width:25%;">
            Code
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ ready.EquipmentCode }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Name
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ ready.EquipmentName }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Start Date
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ ready.StartDate }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Duration
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ ready.Duration }}
          </td>
        </tr>
      </table>

      <template #footer>
        <CButton
          @click="modalOperational = false"
          color="secondary"
          style="font-size: 14px;"
          >Close</CButton
        >
      </template>
    </CModal>
    <CModal
      :show.sync="modalReady"
      size="sm"
      color="info"
      style="margin-top: 30%;"
    >
      <font style="font-size: 14px; width: 80%;"><b>EQUIPMENT DETAIL </b></font>
      <hr />
      <table style="font-size:13px;">
        <tr>
          <td style="padding: 0.3rem; width:25%;">
            Code
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ ready.EquipmentCode }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Name
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ ready.EquipmentName }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Status Date
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ ready.StatusDate }}
          </td>
        </tr>
        <tr>
          <td style="padding: 0.3rem;">
            Note
          </td>
          <td style="padding: 0.3rem; text-align: left;">
            {{ ready.Note }}
          </td>
        </tr>
      </table>

      <template #footer>
        <CButton
          @click="modalReady = false"
          color="secondary"
          style="font-size: 14px;"
          >Close</CButton
        >
      </template>
    </CModal>
  </div>
</template>
<script>
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { DxPieChart, DxConnector } from "devextreme-vue/pie-chart";
import {
  DxSeries,
  DxLegend,
  DxLabel,
  DxFont,
  DxExport,
  DxTooltip,
  DxChart,
  DxCommonSeriesSettings,
  DxArgumentAxis,
  DxGrid,
  DxCrosshair,
  DxPoint,
  DxTitle,
  DxSubtitle,
  DxValueAxis,
} from "devextreme-vue/chart";
import TheSidebar from "../../containers/TheSidebar";
import TheHeader from "../../containers/TheHeader";
import nav from "../../containers/_nav";
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import CryptoJS from "crypto-js";
Vue.use(VueCordova);

export default {
  components: {
    DxChart,
    DxCommonSeriesSettings,
    DxSeries,
    DxArgumentAxis,
    DxGrid,
    DxCrosshair,
    DxExport,
    DxLegend,
    DxPoint,
    DxLabel,
    DxFont,
    DxTitle,
    DxSubtitle,
    DxTooltip,
    TheSidebar,
    TheHeader,
    DxValueAxis,
    DxPieChart,
    DxConnector,
  },
  nav,
  computed: {},
  data() {
    return {
      companyResult: [],
      bepResult: [],
      summaryResult: [],
      breakDownResult: [],
      readyList: [],
      dashboardMop: [],
      operationalList: [],
      standbyList: [],
      breakdown: [],
      operational: [],
      standBy: [],
      ready: [],
      selectedBep: "",
      selectedCompany: "",
      showHeader: false,
      showTable: false,
      modalBreakdown: false,
      modalOperational: false,
      modalStandBy: false,
      modalReady: false,

      urlServer: "",
    };
  },
  methods: {
    start() {
      console.log(localStorage.token);
      let data = localStorage.token;
      if (typeof data == "undefined") {
        this.$router.push({ path: "/logout" });
      } else {
        this.loading = true;
        axios
          .get(`${this.urlServer}/Api/General/GetListBep/`, {
            headers: {
              Authorization: "Bearer " + data,
            },
          })
          .then((res) => {
            console.log(res.data);
            this.bepResult = res.data;
          });

        axios
          .get(`${this.urlServer}/Api/General/GetCurrentShift/`, {
            headers: {
              Authorization: "Bearer " + data,
            },
          })
          .then((res) => {
            this.shiftName = res.data[0].ShiftName;
            this.transDate = res.data[0].TransDate;
            //this.transDate = "2022-05-05";
            console.log(res.data[0]);
          });
      }
    },
    reloadData() {
      let data = localStorage.token;
      const param = {
        prmBepCode: this.selectedBep,
        prmTransDate: this.transDate,
        prmSF: this.shiftName,
        Company: this.selectedBep,
      };
      const form = new FormData();
      form.append("Bep", this.selectedBep);
      form.append("TransDate", this.transDate);
      form.append("Shift", this.shiftName);
      form.append("Company", this.selectedCompany);
      let sendData = JSON.stringify(Object.fromEntries(form));
      this.dashboardMop = [];
      this.breakDownResult = [];
      this.standbyList = [];
      this.readyList = [];
      this.operationalList = [];

      if (this.selectedBep != "" && this.selectedCompany != "") {
        this.data = new Array();
        this.summaryResult = new Array();
        var _bep = this.selectedBep;

        if (typeof data != "undefined") {
          var hauling = new Array();
          if (_bep == "Hauler") {
            axios
              .post(
                `${this.urlServer}/Api/MOP/GetStatusEquipmentHauler/`,
                sendData,
                {
                  headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods":
                      "DELETE, POST, GET, OPTIONS",
                    "Access-Control-Allow-Headers":
                      "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                }
              )
              .then((res) => {
                res.data.forEach(function(entry) {
                  var obj = new Object();
                  obj["bep"] = entry.Status;
                  obj["qty"] = parseFloat(entry.Total);
                  hauling.push(obj);
                });
                this.dashboardMop = hauling;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });
          } else if (_bep == "OHT") {
            axios
              .post(
                `${this.urlServer}/Api/MOP/GetStatusEquipmentOHT/`,
                sendData,
                {
                  headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods":
                      "DELETE, POST, GET, OPTIONS",
                    "Access-Control-Allow-Headers":
                      "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                }
              )
              .then((res) => {
                res.data.forEach(function(entry) {
                  var obj = new Object();
                  obj["bep"] = entry.Status;
                  obj["qty"] = parseFloat(entry.Total);
                  hauling.push(obj);
                });
                this.dashboardMop = hauling;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });
          } else {
            axios
              .post(`${this.urlServer}/Api/MOP/GetStatusEquipment/`, sendData, {
                headers: {
                  "Access-Control-Allow-Origin": "*",
                  "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                  "Access-Control-Allow-Headers":
                    "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + data,
                },
              })
              .then((res) => {
                res.data.forEach(function(entry) {
                  var obj = new Object();
                  obj["bep"] = entry.Status;
                  obj["qty"] = parseFloat(entry.Total);
                  hauling.push(obj);
                });
                this.dashboardMop = hauling;
              })
              .catch((error) => {
                this.loading = false;
                console.error(error);
              });
          }

          axios
            .post(`${this.urlServer}/Api/MOP/GetBreakdownList/`, sendData, {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                "Content-Type": "application/json",
                Authorization: "Bearer " + data,
              },
            })
            .then((res) => {
              this.showTable = true;
              this.breakDownResult = res.data;
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });

          axios
            .post(`${this.urlServer}/Api/MOP/GetStandbyList/`, sendData, {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                "Content-Type": "application/json",
                Authorization: "Bearer " + data,
              },
            })
            .then((res) => {
              this.standbyList = res.data;
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });

          axios
            .post(`${this.urlServer}/Api/MOP/GetOperationalList/`, sendData, {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                "Content-Type": "application/json",
                Authorization: "Bearer " + data,
              },
            })
            .then((res) => {
              this.operationalList = res.data;
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });

          axios
            .post(`${this.urlServer}/Api/MOP/GetReadyList/`, sendData, {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                "Content-Type": "application/json",
                Authorization: "Bearer " + data,
              },
            })
            .then((res) => {
              this.readyList = res.data;
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });

          this.loading = false;
        } else {
          this.loading = false;
          this.$router.push({ path: "/logout" });
        }
      } else {
      }
      this.loading = false;
    },

    formatLabel(pointInfo) {
      return `${pointInfo.value}`;
    },
    show() {
      return this.$store.state.sidebarShow;
    },
    Minimize() {
      return this.$store.state.sidebarMinimize;
    },
    customizeLabel({ value }) {
      return {
        customizeText: function({ valueText }) {
          return `${valueText
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
        },
      };
    },
    customizeText({ valueText }) {
      return `${valueText
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
    },
    customizeTooltip(pointInfo) {
      return {
        text: `${pointInfo.argumentText}
                            <br/>${pointInfo.value
                              .toFixed(2)
                              .toString()
                              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`,
      };
    },
    pieCustomizeTooltip(pointInfo) {
      return {
        text: `${pointInfo.argumentText}
                            <br/>${pointInfo.value}
                            <br/>${pointInfo.percentText}`,
      };
    },

    showModalBreakdown(data) {
      console.log(data);
      this.breakdown = data;
      this.modalBreakdown = true;
    },
    showModalOperational(data) {
      console.log(data);
      this.operational = data;
      this.modalOperational = true;
    },
    showModalStandBy(data) {
      console.log(data);
      this.standBy = data;
      this.modalStandBy = true;
    },
    showModalReady(data) {
      console.log(data);
      this.ready = data;
      this.modalReady = true;
    },
  },
  beforeMount() {
    this.loading = true;
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    const urlS = url.toString(CryptoJS.enc.Utf8);
    this.urlServer = urls;
    let data = localStorage.token;
    const form = new FormData();
    let sendData = JSON.stringify(Object.fromEntries(form));
    if (typeof data != "undefined") {
      axios
        .post(`${urlS}/Api/General/GetCompany/`, sendData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          console.log(res);
          this.companyResult = res.data;
        })
        .catch((error) => {
          let err = error.toString();
          if (err.toString().match(/^.*undefined.*$/)) {
            Vue.$toast.open({
              message: "Sorry, Your token has expired!",
              type: "warning",
              position: "bottom",
            });
            this.$router.push({ path: "/logout" });
          } else {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          }
        });
    } else {
      this.$router.push({ path: "/logout" });
    }

    this.start();
    this.reloadData();
    this.loading = false;
  },
};
</script>
<style>
#chart {
  height: 440px;
}

.tooltip-header {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 5px;
  border-bottom: 1px solid #c5c5c5;
}

.tooltip-body {
  width: 170px;
}

.tooltip-body .series-name {
  font-weight: normal;
  opacity: 0.6;
  display: inline-block;
  line-height: 1.5;
  padding-right: 10px;
  width: 126px;
}

.tooltip-body .value-text {
  display: inline-block;
  line-height: 1.5;
  width: 30px;
}
</style>
